export const HOST: string = process.env.VUE_APP_DEVHOST
  ? process.env.VUE_APP_DEVHOST
  : process.env.NODE_ENV === "development"
  ? "https://squaregroup.com"
  : "";
export const API_URL: string = `${HOST}/api/v2`;
